module.exports = __webpack_public_path__ + "img/B6403_CyclewayVisuals_Location_01a_crop_02.a5e26f0e.jpg";